import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_TEMPLATE_TYPE = "GET_LIST_TEMPLATE_TYPE";
export const GET_DETAIL_TEMPLATE_TYPE = "GET_DETAIL_TEMPLATE_TYPE";
export const UPDATE_TEMPLATE_TYPE = "UPDATE_TEMPLATE_TYPE";
export const SAVE_TEMPLATE_TYPE = "SAVE_TEMPLATE_TYPE";
export const DELETE_TEMPLATE_TYPE = "DELETE_TEMPLATE_TYPE";
export const SET_LIST_TEMPLATE_TYPE = "DELETE_TEMPLATE_TYPE";
export const SET_DETAIL_TEMPLATE_TYPE = "SET_DETAIL_TEMPLATE_TYPE";


const state = {
    listTemplateType: [],
    templateTypeDetail: {}
};

const getters = {
    listTemplateType(state) {
        return state.listTemplateType;
    },
    templateTypeDetail(state) {
        return state.templateTypeDetail;
    },


};

const actions = {
    [GET_LIST_TEMPLATE_TYPE](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_TEMPLATE_TYPE}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_TEMPLATE_TYPE, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_TEMPLATE_TYPE](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_TEMPLATE_TYPE}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_TEMPLATE_TYPE, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_TEMPLATE_TYPE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_TEMPLATE_TYPE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_TEMPLATE_TYPE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPDATE_TEMPLATE_TYPE}/${payload.id}?_method=PUT`, payload.data)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_TEMPLATE_TYPE](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_TEMPLATE_TYPE}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_TEMPLATE_TYPE](state, data) {
        state.listTemplateType = data.data;
    },
    [SET_DETAIL_TEMPLATE_TYPE](state, data) {
        state.templateTypeDetail = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};